import { SidebarGroup, SidebarGroupContent, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from 'shared/ui/sidebar';
import { type LucideIcon } from 'lucide-react';
import { Link } from 'shared/lib/i18n';
export const HelperNav = ({
  items,
  ...props
}: {
  items: {
    title: string;
    url: string;
    icon: LucideIcon;
  }[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) => {
  return <SidebarGroup {...props} data-sentry-element="SidebarGroup" data-sentry-component="HelperNav" data-sentry-source-file="helper-nav.tsx">
      <SidebarGroupContent data-sentry-element="SidebarGroupContent" data-sentry-source-file="helper-nav.tsx">
        <SidebarMenu data-sentry-element="SidebarMenu" data-sentry-source-file="helper-nav.tsx">
          {items.map(item => <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild size="sm">
                <Link href={item.url} target="_blank" rel="noopener noreferrer">
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>)}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>;
};